<template>
  <v-chip-group>
    <v-chip
      v-for='(role, index) in roles'
      :key='index'
      small
      :color='getColor(role)'
      dark
    >
      {{ role }}
    </v-chip>
  </v-chip-group>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'contact-role-chips',
  props: {
    relationship: {
      required: true
    },
  },
  computed: {
    roles () {
      return _.split(this.relationship, ',')
    }
  },
  methods: {
    getColor(role) {
      if (role === 'Owner') {
        return 'grey darken-3'
      } else if (role === 'Billing') {
        return 'green darken-2'
      } else if (role === 'Notices') {
        return 'orange'
      } else if (role === 'Install Contact') {
        return 'brown'
      } else if (role === 'Sales') {
        return 'purple'
      } else if (role === 'Site Contact') {
        return 'blue'
      } else if (role === 'Alt Site Contact') {
        return 'blue lighten-2'
      } else if (role === 'Service Contact') {
        return 'green'
      } else if (role === 'Alt Service Contact') {
        return 'green lighten-2'
      }
    }
  }
}
</script>